import {url} from "../../client/Actions";


const utils = {
  isEquals: (f, v) => {
    return f === v;
  },
  isNonEmpty: (v) => {
    return (v == false && v !== "" || v && v !== "none" && v !== "") ? true : false;
  },
  isNonNull: (v) => {
    return (v && v !== "") ? true : false;
  },
  isNull: (v) => {
    return (v === null) ? true : false;
  },
  defaultUrl: () => {
    return  url()
  },
  openFile: (filePath) => {
    window.open(utils.defaultUrl() + filePath, "_blank", "width=1100,height=400px,resizable=1");
  },
  numberWithSpaces: (v) => {
    return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

};



export default utils;
